module.exports = __webpack_public_path__ + "img/programme5.ac95a0de.png";